import { SET_RECRUITERS_FEES_LIST, FETCH_ALL } from './types.js'

export default {
  /**
   * Fetch all enteries from recruiters fees table
   */
  async [FETCH_ALL]({ commit }) {
    try {
      const response = await this._vm.$network_utils.getRecruiterFees()
      commit(SET_RECRUITERS_FEES_LIST, response)
    } catch (e) {
      console.error(e)
    }
  },
}
